import { gameManagement } from "./pages/game-management";
import { lobbyManagement } from "./pages/lobby-management";
import { playerManagement } from "./pages/player-management";
import { signIn } from "./pages/sign-in";
import { tableManagement } from "./pages/table-management";
import { tenantManagement } from "./pages/tenant-management";
import { transactionManagement } from "./pages/transaction-management";
import { userManagement } from "./pages/user-management";

/// components
import { selects } from "./components/selects";

export default {
  root: {
    delete_confirmation_title: "Are you sure delete this item?",
    delete_confirmation_message: "Are you sure you want to delete this item?",
    delete_success: "Item deleted successfully",
    delete_error: "Error deleting item",
    confirm: "Confirm",
    cancel: "Cancel",
    edit_button: "Edit Data",
    delete_button: "Delete",
    save_button: "Save",
    go_back_button: "Go Back",
    next_button: "Next",
    refresh_button: "Refresh",
    add_button: "Add Item",
    actions_button: "View",
    details: "Details",
    online_view: "Online View",
    show_transaction: "Transactions",
    transactions: "Transactions",
    yes: "Yes",
    no: "No",
    copy_success: "Copied to clipboard",
    copy_button: "Copy",
    empty: "Empty",
    search: "Search",
    won: "Won !",
  },
  sidebar: {
    logout: "Logout",
    search_input_placeholder: "Search...",
    menu: {
      home: "Home",
      dashboard: "Dashboard",
      "table-management": "Table List",
      "game-management": "Game History",
      "transaction-management": "History",
      "lobby-management": "Lobby List",
      "user-management": "Admin List",
      "tenant-management": "Tenant List",
      "operator-management": "Operator List",
      "player-management": "Player List",
    },
  },
  dashboard: {
    title: "Welcome to Dashboard {{name}}",
    description: "This is the dashboard page. You can select a menu on the left side.",
  },
  ...lobbyManagement,
  ...tableManagement,
  ...gameManagement,
  ...tenantManagement,
  ...userManagement,
  ...playerManagement,
  ...signIn,
  ...transactionManagement,
  // components
  ...selects,
};
